import { excludesAll, includesAll, includesAny } from 'onboarding-scopes/utils/arrayUtils';
import { ALL_TRIAL_SCOPES, ENTERPRISE_TRIAL_SCOPES, PRO_TRIAL_SCOPES, TRIAL_SCOPES } from './trialScopes';
const {
  TRIAL_MARKETING_HUB_PROFESSIONAL,
  TRIAL_MARKETING_HUB_ENTERPRISE,
  TRIAL_CMS_HUB_PROFESSIONAL,
  TRIAL_CMS_HUB_ENTERPRISE,
  TRIAL_COMMERCE_HUB_PROFESSIONAL,
  TRIAL_COMMERCE_HUB_ENTERPRISE,
  TRIAL_SALES_HUB_PROFESSIONAL,
  TRIAL_SALES_HUB_ENTERPRISE,
  TRIAL_SERVICE_HUB_PROFESSIONAL,
  TRIAL_SERVICE_HUB_ENTERPRISE,
  TRIAL_OPERATIONS_HUB_PROFESSIONAL,
  TRIAL_OPERATIONS_HUB_ENTERPRISE
} = TRIAL_SCOPES;
export const hasActiveTrial = scopes => includesAny(scopes, ALL_TRIAL_SCOPES);
export const hasActiveProTrial = scopes => includesAny(scopes, PRO_TRIAL_SCOPES);
export const hasOnlyActiveProTrial = scopes => includesAny(scopes, PRO_TRIAL_SCOPES) && excludesAll(scopes, ENTERPRISE_TRIAL_SCOPES);
export const hasActiveEnterpriseTrial = scopes => includesAny(scopes, ENTERPRISE_TRIAL_SCOPES);
export const hasOnlyActiveEnterpriseTrial = scopes => excludesAll(scopes, PRO_TRIAL_SCOPES) && includesAny(scopes, ENTERPRISE_TRIAL_SCOPES);
export const hasActiveMarketingHubProTrial = scopes => scopes.includes(TRIAL_MARKETING_HUB_PROFESSIONAL);
export const hasActiveMarketingHubEnterpriseTrial = scopes => scopes.includes(TRIAL_MARKETING_HUB_ENTERPRISE);
export const hasActiveContentHubProTrial = scopes => scopes.includes(TRIAL_CMS_HUB_PROFESSIONAL);
export const hasActiveContentHubEnterpriseTrial = scopes => scopes.includes(TRIAL_CMS_HUB_ENTERPRISE);
export const hasActiveSalesHubProTrial = scopes => scopes.includes(TRIAL_SALES_HUB_PROFESSIONAL);
export const hasActiveSalesHubEnterpriseTrial = scopes => scopes.includes(TRIAL_SALES_HUB_ENTERPRISE);
export const hasActiveServiceHubProTrial = scopes => scopes.includes(TRIAL_SERVICE_HUB_PROFESSIONAL);
export const hasActiveServiceHubEnterpriseTrial = scopes => scopes.includes(TRIAL_SERVICE_HUB_ENTERPRISE);
export const hasActiveOpsHubProTrial = scopes => scopes.includes(TRIAL_OPERATIONS_HUB_PROFESSIONAL);
export const hasActiveOpsHubEnterpriseTrial = scopes => scopes.includes(TRIAL_OPERATIONS_HUB_ENTERPRISE);
export const hasActiveCommerceHubProTrial = scopes => scopes.includes(TRIAL_COMMERCE_HUB_PROFESSIONAL);
export const hasActiveCommerceHubEnterpriseTrial = scopes => scopes.includes(TRIAL_COMMERCE_HUB_ENTERPRISE);
export const hasActiveMarketingProPlusTrial = scopes => includesAll(scopes, [TRIAL_MARKETING_HUB_PROFESSIONAL, TRIAL_CMS_HUB_PROFESSIONAL]);
export const hasActiveMarketingEnterprisePlusTrial = scopes => includesAll(scopes, [TRIAL_MARKETING_HUB_ENTERPRISE, TRIAL_CMS_HUB_ENTERPRISE]);